function parseApiVersionParts(version) {
  const raw = String(version || '').trim();
  if (!raw) {
    return [];
  }

  return raw
    .split('.')
    .map((part) => parseInt(part, 10))
    .filter((part) => Number.isFinite(part));
}

export function compareApiVersions(actualVersion, requiredVersion) {
  const actualParts = parseApiVersionParts(actualVersion);
  const requiredParts = parseApiVersionParts(requiredVersion);
  const maxLength = Math.max(actualParts.length, requiredParts.length);

  for (let index = 0; index < maxLength; index += 1) {
    const actual = actualParts[index] || 0;
    const required = requiredParts[index] || 0;

    if (actual > required) return 1;
    if (actual < required) return -1;
  }

  return 0;
}

export function isApiVersionGte(actualVersion, requiredVersion) {
  return compareApiVersions(actualVersion, requiredVersion) >= 0;
}
